function formatDuration(duration) {
  if (duration === undefined || duration === null) {
    return ''
  }
  let h = parseInt(duration / 3600)
  let m = parseInt(duration / 60)
  m = m % 60;
  let s = duration % 60
  let str = '';
  str += h > 0 ? (h + this.langText("PAGE_HEADER_TITLE.time_hour")) : ''
  str += m > 0 ? (m + '分') : ''
  str += s > 0 ? (s + '秒') : ''
  return str;
}


//乘法
function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}
//加法
function accAdd(arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}
//减法
function subtr(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}



function formatDurationSimple(duration) {

  if (duration === undefined || duration === null) {
    return ''
  }
  let h = parseInt(duration / 3600)
  let m = parseInt(duration / 60)
  let s = duration % 60
  let str = '';
  str += h > 0 ? (h + ':') : ''
  str += m >= 0 ? ((m < 10 ? "0" + m : (m)) + ':') : '00'
  str += s > 0 ? (s < 10 ? "0" + s : (s)) : '00'

  return str;
}

function formatSeconds(value) {
  var theTime = parseInt(value); // 秒
  var theTime1 = 0; // 分
  var theTime2 = 0; // 小时
  // alert(theTime);
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    // alert(theTime1+"-"+theTime);
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
    }

  }
  var result = "" + parseInt(theTime) + "秒";
  if (theTime1 > 0) {
    result = "" + parseInt(theTime1) + "分" + result;
  }
  if (theTime2 > 0) {
    result = "" + parseInt(theTime2) + this.langText("PAGE_HEADER_TITLE.time_hour") + result;
  }
  return result;

}


function formatPrice(price, rate) {
  let r = rate ? rate : 100;
  if (price == undefined) {
    return null
  }
  let yuan = parseInt(price / r)
  let cen = price % r;
  let pStr = yuan
  pStr += cen > 0 ? ('.' + cen) : ''
  return pStr;
}

function formatPriceH5(price, rate = 1) {
  let r = 100;
  if (price == undefined || price == 0 || price == "") {
    return price
  }
  // let yuan = parseInt(price / r * rate)
  // let cen = price % (r/rate);
  // let pStr = yuan
  // pStr += cen > 0 ? ('.' + cen) : ''
  let pStr = (price / r)
  if(pStr % 1 != 0){
    pStr = pStr.toFixed(2)
  }
  console.log(pStr)
  return pStr;
}
function formatPriceShowH5(price, rate = 1) {
  let r = 100;
  if (price == undefined || price == 0 || price == "") {
    return price
  }
  let pStr
  if(rate == 1){
    //pStr = (price / r * rate).toFixed(2)
    pStr = (price / r * rate)
    if(pStr % 1 != 0){
      pStr = pStr.toFixed(2)
    }
  }else{
    pStr = Math.round((price / r * rate))
  }
  return pStr;
}

function formatPriceH5d(price, rate = 1, discount) {
  if(discount == undefined || discount == 0){
    discount = 1
  }else{
    discount = discount / 100
  }
  let r = 100;
  if (price == undefined) {
    return null
  }
  let yuan = parseInt(price / r * rate * discount)
  //let cen = price % (r/rate * discount);
  let pStr = yuan
  //pStr += cen > 0 ? ('.' + cen) : ''
  // console.log(pStr)
  return pStr;
}


function copyObj(r, s, isOverWrite) {
  if (!s || !r) return r
  for (var p in s) {
    if (isOverWrite !== false || !(p in r)) {
      r[p] = s[p]
    }
  }
  return r
}

//2019-03-03
function formatYMD(value) {
  let date = new Date(value.replace(/-/g, "/"));
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ("0" + m) : m;
  let d = date.getDate();
  d = d < 10 ? ("0" + d) : d;
  return y + "-" + m + "-" + d;
}

function splitYMD(value) {
  if (value != undefined) {
    let data = value.split(' ');
    return data[0].replace(/-/g, ".");
  }
}

//時間-轉/
function YMD(value) {
  return value.replace(/-/g, "/")
}



function chackNative() {
  //检测native环境
  var isNative = ''
  try {
    //native环境
    // console.log('test ntive', native);
    native.getDeviceInfo();
    // console.log('chack is native');
    // Vue.prototype.NATIVEDATA = JSON.parse(native.getDeviceInfo());
    // Vue.prototype.ccIsNative = true;
    // this.GLOBAL_.ccRequest.setNative(JSON.parse(native.getDeviceInfo()));
    return true
  } catch (error) {
    // console.log(error);

    // console.log("chack 沒有native運行時環境utils！");
    return false
  }
}

//時間切割   2019-01-02-2019-02-02
function timeSplit(value) {

  if (value.indexOf("天") > 0) {
    // let time = new Date();
    // let yy = time.getFullYear();
    // let mm = time.getMonth() + 1;
    // let dd = time.getDate();
    // let timeArray = value.split('有效期');
    // let timeNumber = timeArray[1].split('天')[0];
    // mm = mm < 10 ? '0' + mm : mm;
    // dd = dd < 10 ? '0' + dd : dd;
    // let startTime = yy + "/" + mm + "/" + dd;

    // let endTime = new Date((new Date(startTime).getTime()) + (timeNumber * 86400000));
    // let endYY = endTime.getFullYear();
    // let endMM = endTime.getMonth() + 1;
    // let endDD = endTime.getDate();
    // endMM = endMM < 10 ? '0' + endMM : endMM;
    // endDD = endDD < 10 ? '0' + endDD : endDD;
    // // console.log(timeNumber,yy,mm,dd,endYY,endMM,endDD)
    // return yy + "." + mm + "." + dd + " - " + endYY + "." + endMM + "." + endDD;
    return value;
  } else {
    let time = value.split('-');
    // return time[0] + "." + time[1] + "." + time[2] + " - " + time[3] + "." + time[4] + "." + time[5]
    return time[0] + "." + time[1] + "." + (time[2].split(' ')[0]) + " - " + time[3] + "." + time[4] + "." + (time[5].split(' ')[0]);
  }
}



/**分割url方法，页面统一调用
 * @param  {} pageName
 */
function splitUrl(pageName) {
  // alert(window.location.href.split('#/app')[0] + '#/app/' + pageName)
  return window.location.href.split('#/app')[0] + '#/app/' + pageName
}

/** js计算rem
 *
 */
function calcRem(num) {
  let newN = num.replace(/px/g, '')

  return (newN / 75) + 'rem'

}

/*
給圖片添加播放器事件
*/
function addImgPicture(domId, callbackFun) {
  console.log(123, callbackFun);

  let imgs = document
    .getElementById("detail_html")
    .querySelectorAll("img");

  imgs.forEach((img, k) => {
    //console.log("img", img);

    img.num = k;
    img.removeEventListener("click", this.imgClick);
    img.addEventListener("click", this.imgClick);
  });

}

/** 根据dpr返回尺寸
 *  去除两位小数点
 *
 */
function calcDpr(dpr, num) {
  let newD = 2
  return parseInt(newD * num)
}

function setPhotoSize(dpr, num) {
  let newD = 2
  let text = '?x-oss-process=image/resize,w_' + this.calcDpr(newD, num)
  // let text = '?x-oss-process=image/resize,w_' + this.calcDpr(dpr, num)
  return text
}



/** 友盟事件上報
 * @param  {string} umengId  友盟事件ID
 * @param  {string} types    分類名
 * @param  {string} value      值
 * @param  {array}  extend    擴展參數,上報多個時用數組如
    [{id:'id',objs:{page:'首頁'}}]
 */

let maxLength = 2;
let dataArray = [];

function umengReport(umengId, obj, extend) {
  //增加Promise容错
  return new Promise(function (resolve, reject) {

    try {
      let umengData = localStorage.getItem('umengData');
      // console.log(umengId,obj);
      // return new Promise(function (resolve, reject) {
      dataArray.push({
        objs: obj,
        id: umengId
      })
      if (extend) {
        dataArray = dataArray.concat(extend);
      }

      // console.log(dataArray,umengData,extend)
      if (umengData == '' || umengData == null || umengData == undefined) {
        // console.log(dataArray,umengData)
        onEventWithJsonStr(dataArray)
      } else {
        let umengArray = JSON.parse(umengData);
        let countArray = umengArray.concat(dataArray);
        // console.log(umengArray,dataArray,countArray,'缓存和页面')
        onEventWithJsonStr(countArray)
      }
      resolve()
    } catch (error) {
      console.log('youmen error', error);
    }

    // })

    // return new Promise(function (resolve, reject) {

    //     try {

    //         native.onEventWithJsonStr(umengId, JSON.stringify(obj));
    //         resolve()
    //     } catch (error) {
    //         //友盟事件上報失敗處理

    //         // console.log('run umeng err');


    //     }



    // })

    // alert(JSON.stringify(obj))
    // alert(umengId)
  })
}

function onEventWithJsonStr(data) {
  // console.log(data,"缓存加页面")
  if (data.length > maxLength) {
    localStorage.removeItem('umengData');
    dataArray = [];
    for (let i = 0; i < data.length; i++) {
      // console.log(data[i].id, JSON.stringify(data[i].objs))
      native.onEventWithJsonStr(data[i].id, JSON.stringify(data[i].objs));
    }

  } else {
    // console.log('不报',data)
    let storage = {
      key: 'umengData',
      value: JSON.stringify(data)
    };
    // console.log(storage)
    localStorage.setItem(JSON.stringify(storage))
  }
}


/**裁剪日期
+ * @param  {String} date
+ */
function cropDay(date) {

  // return date.split(' ')[0]
  if (date != undefined) {
    return date.split(' ')[0]

  }
}

/** 檢查語言
+ * @param  {} code
+ */
function checkLanguage(code) {
  var text = ''
  switch (code) {
    case 'Chinese':
      text = langText("UTILS_LANG.lang0") //'普通話'
      break;
      // case 'Cantonesesss': //Cantonese   暫時註釋不顯示
      //   text = langText("UTILS_LANG.lang1") //'廣東話'
      //   break;
      // case 'Cantonese': //Cantonese   暫時註釋不顯示
      //   text = langText("UTILS_LANG.lang1") //'廣東話'
      //   break;
    case 'English':
      text = langText("UTILS_LANG.lang2") //'英語'
      break;
  }

  return text
}

//获取当前语言
function getLanguage(isDev) {
  var lang = "zh-hk";
  if (!isDev && chackNative()) {
    let langData = localStorage.getItem("lang");
    if (langData && JSON.parse(langData).type == true) {
      lang = JSON.parse(langData).lang
    }
  }

  return lang
}


//半角转化全角
function toDash(txtstring) {

  if (!txtstring) {
    return
  }


  let textArr = txtstring.split('')

  for (var i = 0; i < txtstring.length; i++) {

    if (textArr[i] == '—') {
      textArr[i] = '─'
    }
  }

  return textArr.join('');
}

/**
 *
 * 一周内轉換 相對今天轉換時間
 * {value}  時間戳
 */
function weekTime(value) {

  let text = "";

  //今天日期
  let getTime = new Date();
  let YY = getTime.getFullYear();
  let MM = getTime.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let DD = getTime.getDate();
  DD = DD < 10 ? "0" + DD : DD;
  let YMD = YY + "/" + MM + "/" + DD;
  // console.log(YMD)

  //傳入的日期
  let timsString = value.replace(/-/g, "/")
  let date = new Date(timsString);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let ymd = y + "/" + m + "/" + d
  let h = date.getHours();
  h = h < 10 ? '0' + h : h;
  let mt = date.getMinutes();
  mt = mt < 10 ? '0' + mt : mt;
  let s = date.getSeconds();
  s = s < 10 ? '0' + s : s;
  // let sfm=h+":"+mt+":"+s
  let sfm = h + ":" + mt
  // console.log(y + "/" + m + "/" + d,sfm)


  //一周開始與結束日期
  var nowTime = getTime.getTime();
  var day = getTime.getDay();
  var oneDayTime = 24 * 60 * 60 * 1000;
  var mondayTime = nowTime - (day - 1) * oneDayTime; //显示周一
  var sundayTime = nowTime + (7 - day) * oneDayTime; //显示周日
  let monday = new Date(mondayTime).getFullYear() + '/' + (new Date(mondayTime).getMonth() + 1) + "/" + new Date(mondayTime).getDate() + " 00:00:00";
  let sunday = new Date(sundayTime).getFullYear() + '/' + (new Date(sundayTime).getMonth() + 1) + "/" + new Date(sundayTime).getDate() + " 23:59:59";

  // console.log(monday);
  // console.log(sunday)

  // console.log(date.getTime(), new Date(monday).getTime(),new Date(sunday).getTime())
  if (y == YY && m == MM && DD == d) {
    text = '今天 ' + sfm;
  } else {

    if (date.getTime() < new Date(monday).getTime() || date.getTime() > new Date(sunday).getTime()) {
      // console.log("不在星期内")
      text = y + "-" + m + "-" + d + " " + sfm;
    } else {
      // console.log("在星期内")
      let w = "";
      let wek = date.getDay();
      if (wek == 1) {
        w = "一";
      } else if (wek == 2) {
        w = "二";
      } else if (wek == 3) {
        w = "三";
      } else if (wek == 4) {
        w = "四";
      } else if (wek == 5) {
        w = "五";
      } else if (wek == 6) {
        w = "六";
      } else if (wek == 0) {
        w = "日";
      }
      text = "星期" + w + " " + sfm;
    }


  }

  // console.log(text)
  return text;
}

function timestampToTime(timestamp) {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000   
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return Y + M + D; //时分秒可以根据自己的需求加上
}

function title(value) {
  let text = value.split('【');
  if (text.length > 1) {
    let title = text[1].split('】');
    return title[0]
  } else {
    return text[0]
  }
}

function timgYmd(value) {
  let date = new Date(value);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ("0" + m) : m;
  let d = date.getDate();
  d = d < 10 ? ("0" + d) : d;
  return y + "/" + m + "/" + d;
}

//
// function getLanguage() {
//   var lang = "zh-hk";
//   let langData = native.getStorage("lang");
//
//   if (langData && JSON.parse(langData).type == true) {
//     lang = JSON.parse(langData).lang
//   }
//   return lang;
// }


let langTW = require("../common/lang/tw.js");
let langZH = require("../common/lang/zh.js");
// let langData = native.getStorage("lang");



function langText(code) {
  //默认繁体字

  let lang;
  if (getLanguage() == "zh-hk") {
    lang = langTW;
  } else {
    lang = langZH;
  }
  let dotCode = code.split('.')

  let result = ''
  if (dotCode.length > 0) {
    let obj = lang[dotCode[0]]
    dotCode.forEach((v, k) => {
      if (k != 0) {
        obj = obj[dotCode[k]]
      }
    })

    result = obj

  } else {
    result = langTW[code]
  }

  return result

}

//转换size
function changeSize(size, unit) {
  if (unit) {
    return (size / Math.pow(1024.00, 2)).toFixed(2) + unit; //M
  } else {
    return (size / Math.pow(1024.00, 2)).toFixed(2); //M
  }

}

function calculateTime(value) {
  let time = value.split('-');
  let start = time[0];
  let end = time[1];
  let day = new Date(end) - new Date(start);
  if (day <= 7) {
    return day;
  }
}

//檢查網絡狀態
function checkNetWork(num) {

  return new Promise((resolve, reject) => {
    let status = native.getNetworkStatus()
    // console.log('网络状态', status);

    if ((num == 0 && status == -1) || status == num) {
      return resolve()
    } else {
      return reject()
    }

  })

}

/**
 * @param  {String} value  需要大於版本  例如傳入1.2  客戶端版本爲1.2以上則resolve
 */
function checkAppVersion(value) {
  return new Promise(function (resolve, reject) {
    var nativeData = JSON.parse(native.getDeviceInfo()).appVersion
    let numberArray = nativeData.split("."); //客户端
    let numberArray2 = value.split("."); ///传入

    let appVersion = ""; //客户端
    let appVersion2 = ""; //传入
    for (let i = 0; i < numberArray.length; i++) {
      appVersion = appVersion + numberArray[i]
    }

    for (let o = 0; o < numberArray2.length; o++) {
      // alert(o)
      appVersion2 = appVersion2 + numberArray2[o]
    }
    let n = appVersion.length - appVersion2.length;

    for (let t = 0; t < Math.abs(n); t++) {
      if (n > 0) {
        appVersion2 = appVersion2 + "0"
      } else {
        appVersion = appVersion + "0"
      }

    }
    // alert(appVersion2+"-"+appVersion)
    if (parseInt(appVersion2) < parseInt(appVersion)) {
      resolve(true)
    } else {
      reject(false)
    }
  })
}

//昵称显示截取
function setnickname(data, type){
  let name = data
  if(type == 'email'){
    return name.match(/(\S*)@/)[1]
  }
  if(type == 'phone'){
    return name.substr(-4)
  }
}

//判断渠道
function fromeAppid(appid){
  if(appid == 'mylink'){
    return false
  }else{
    return true
  }
}

import {Toast, Dialog, Loading  } from 'vant';
function showToast(text){
  Toast(text);
  // Toast({
  //   duration: 0,
  //   message: text,
  // });
}
function showLoadingText(text){
  Toast.loading({
    message: text || this.langText("LOADING"),
    forbidClick: true,
    loadingType: 'circular',
    duration:0,//0不消失
    });
}
function hideLoading(){
  Toast.clear()
}
function showSuccessToast(text){
  Toast.success(text)
}
function showFailToast(text){
  Toast.fail(text)
}

export default {
  formatDuration,
  formatDurationSimple,
  formatPrice,
  copyObj,
  chackNative,
  splitUrl,
  calcRem,
  formatSeconds,
  calcDpr,
  setPhotoSize,
  umengReport,
  formatYMD,
  splitYMD,
  YMD,
  accMul,
  accAdd,
  subtr,
  timeSplit,
  weekTime,
  checkLanguage,
  toDash,
  cropDay,
  timestampToTime,
  title,
  timgYmd,
  langText,
  getLanguage,
  changeSize,
  checkNetWork,
  calculateTime,
  checkAppVersion,
  addImgPicture,
  showToast,
  showLoadingText,
  hideLoading,
  showSuccessToast,
  showFailToast,
  formatPriceH5 ,
  formatPriceH5d,
  formatPriceShowH5,
  setnickname,
  fromeAppid
}



// WEBPACK FOOTER //
// ./src/utils/utils.js